export default function (name) {
  const metaTag = document.head.querySelector(`meta[name=${name}]`)

  if (metaTag) {
    return metaTag.getAttribute('content')
  }

  return null
}
